<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12" style="background-color: #f1f2f3">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv certiDiv hospital-div-wrap">
          <div class="col-sm-12 col-xs-12">
            <div
              class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
              <div>
                <h3 class="subTitle">{{ $t('companyinfo_header_title') }}</h3>
                <h5>
                  {{ $t('companyinfo_header_desc') }}
                </h5>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4>{{ $t('companyinfo_company_subtitle') }}</h4>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >
                    {{ $t('companyinfo_companyname') }}
                  </label>
                  <a-input 
                    :value="data.corpName" 
                    readonly 
                    disabled
                  />
                </div>
                <div class="col-sm-12 inputDiv align-items-start fileDiv">
                  <label class="label-title" >{{ $t('companyinfo_companylogo') }}</label>

                  
                  <div class="file-box" v-if="!isDentium && (data.profileImgUrl || data.fileData)">
                    <!-- </div> -->
                    <img
                      v-if="data.profileImgUrl || data.fileData"
                      :src="data.profileImgUrl"
                      alt="로고 이미지"
                      ref="imgPrevW"
                      id="imgPrevW"
                    />
                    <!-- <div class="file-box" v-else> -->
                  </div>
                  <div class="file-box" v-if="isDentium">
                    <!-- </div> -->
                    <img
                      v-if="data.profileImgUrl || data.fileData"
                      :src="data.profileImgUrl"
                      alt="로고 이미지"
                      ref="imgPrevW"
                      id="imgPrevW"
                      @click="downloadLogoImage()"
                    />
                    <!-- <div class="file-box" v-else> -->
                    <i class="fa-solid fa-image" v-else/>
                    <span v-else>
                      {{ $t('companyinfo_companylogo_placeholder1') }}<br/>{{ $t('companyinfo_companylogo_placeholder2') }}
                    </span>
                    <input
                      type="file"
                      accept="image/jpeg, image/png"
                      @change="changeLogoImage()"
                      id="fileInputW"
                      ref="fileInputW"
                    />
                  </div>
                  <div class="button-box d-flex flex-column" v-if="isDentium">
                    <div class="d-flex">
                      <a-button class="black" @click="clickFileInput()">
                        {{ $t('companyinfo_image_btn_upload') }}
                      </a-button>
                    </div>
                    <div>
                      <ul>
                        <li>
                          {{ $t('companyinfo_image_size') }}
                        </li>
                        <li>
                          {{ $t('companyinfo_image_extension') }}
                        </li>
                        <li>
                          {{ $t('companyinfo_image_filesize') }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="card content-wrap-card col-sm-12 col-xs-12 cm">
                <h4 style="margin-bottom: 5px;">{{ $t('companyinfo_admin_subtitle') }}</h4>
                <h5 class="col-sm-12 inputDiv" >
                  {{ $t('companyinfo_admin_desc') }}
                </h5>
                <div class="col-sm-12 inputDiv" style="margin-top: 16px;">
                  <label class="label-title" >{{ $t('companyinfo_adminname') }}</label>
                  <a-input :value="data.adminName" readonly disabled />
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('companyinfo_adminduty') }}</label>
                  <a-input :value="data.adminDuty" readonly disabled />
                </div>
                <div class="col-sm-12 inputDiv">
                  <label class="label-title" >{{ $t('companyinfo_adminid') }}</label>
                  <a-input :value="data.adminId" readonly disabled />
                </div>
                <div class="col-sm-12 inputDiv password-area" v-if="isDentium && !hidePasswordChange">
                  <label class="label-title" >{{ $t('companyinfo_password') }}</label>
                  <a-button type="primary" @click="toggleChangePassword(true)" v-if="!isChangingPassword">
                    <template #icon>
                      <i class="fa-solid fa-lock" />
                    </template>
                    {{ $t('companyinfo_change') }}
                  </a-button>
                  <a-button type="primary"  @click="changePassword" v-if="isChangingPassword" style="margin-right: 10px">
                    <i class="fa-solid fa-lock-open" />
                    {{ $t('companyinfo_pw_btn_okay') }}
                  </a-button>
                  <a-button v-if="isChangingPassword" @click="toggleChangePassword(false)">
                    {{ $t('companyinfo_pw_btn_cancel') }}
                  </a-button>
                </div>
                <div 
                  v-if="isChangingPassword"
                  style="display: flex; flex-direction: column; gap: 12px;"
                >
                  <div class="d-flex password-wrap" style="flex-direction: column;">
                    <div class="col-sm-12 inputDiv password-area password-input-area mb-0">
                      <label class="label-title" >{{ $t('companyinfo_currentpw') }}</label>
                        <a-input-password
                          class="input-text-common w-25" 
                          :placeholder="$t('companyinfo_currentpw_placeholder')"
                          v-model:value="currentPassword"
                          @keyup.enter="signIn"
                      >
                          <template #prefix>
                              <i class="fa-regular fa-key" />
                          </template>
                      </a-input-password>
                    </div>
                    <div class="col-sm-12 inputDiv password-area fail" ref="passwordInput1"/>
                  </div>
                  <div class="d-flex password-wrap" style="flex-direction: column">
                    <div class="col-sm-12 inputDiv password-area password-input-area mb-0">
                      <label class="label-title" >{{ $t('companyinfo_newpw') }}</label>
                      <a-input-password
                          class="input-text-common w-25" 
                          :placeholder="$t('companyinfo_newpw_placeholder')"
                          v-model:value="newPassword"
                          @keyup.enter="signIn"
                      >
                          <template #prefix>
                              <i class="fa-regular fa-key" />
                          </template>
                      </a-input-password>
                    </div>
                    <div class="col-sm-12 inputDiv password-area fail" ref="passwordInput2"/>
                  </div>
                  <div class="d-flex password-wrap" style="flex-direction: column">
                    <div class="col-sm-12 inputDiv password-area password-input-area mb-0">
                      <label class="label-title" >{{ $t('companyinfo_confirmpw') }}</label>
                        <a-input-password
                            class="input-text-common w-25" 
                            :placeholder="$t('companyinfo_confirmpw_placeholder')"
                            v-model:value="newPasswordConfirm"
                            @keyup.enter="signIn"
                        >
                            <template #prefix>
                                <i class="fa-regular fa-key" />
                            </template>
                        </a-input-password>
                    </div>
                    <div class="col-sm-12 inputDiv password-area fail" ref="passwordInput3"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { blockedInSupportTab } from '@/utils/supportSession';
import { getAccessToken, isSupportTab } from '@/utils/tokenStore';
import { masterCheckUsername } from '@/utils/supportMaster';

import { jwtDecoder, changeBytesToMegabytes, oneBtnDialog } from '../utils/utils';
import { companyLogos, } from '../utils/enums';

export default {
  name: 'companyInfo',
  data() {
    return {
      data: {
        adminId: '',
        adminName: '',
        adminDuty: '',
        ceo: '',
        corpName: '',
        fileName: '', // 이미지 파일명
        fileData: null, // 실제 파일 정보가 담긴 폼데이터
        profileImgUrl: '', // objectStorage 상 이미지 url
      },
      email: 'info@certilife.co',
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',

      isChangingPassword: false,
      isDentium: false,
      // 지원 탭(서브 계정)은 비밀번호가 없어 바꾸기를 숨김(W6 C3)
      hidePasswordChange: blockedInSupportTab('passwordChange', isSupportTab()),

    };
  },
  async created() {
    await this.getCompanyInfo();

  },
  async mounted() {
  },
  methods: {
    async getCompanyInfo() {
      const companyId = jwtDecoder(getAccessToken());
      try {
        const response = await this.$apiInstance.get(`/companies/${companyId}`);
        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          this.data.adminId = data.accountInfo.username;
          this.data.adminName = data.accountInfo.name;
          this.data.adminDuty = data.accountInfo.duty;
          this.data.ceo = data.ceo;
          this.data.corpName = data.name;
          this.data.profileImgUrl = data.imgUrl;
          if(masterCheckUsername(data.accountInfo.username, this.$store.state.privileges) === 'dentium') { // 지원 탭 = 그 회사 최상위 관리자(utils/supportMaster)
            this.isDentium = true;
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('get_comanyinfo_error_title'), this.$i18n.t('get_comanyinfo_error_content'), false);
      }
    },
    toggleChangePassword(status) {
      if(status) {
        this.isChangingPassword = true;
      } else {
        this.isChangingPassword = false;
      }
    },
    initErrorMessage() {
      this.$refs.passwordInput1.innerHTML = '';
      this.$refs.passwordInput2.innerHTML = '';
      this.$refs.passwordInput3.innerHTML = '';
      this.$refs.passwordInput1.style.display = 'none';
      this.$refs.passwordInput2.style.display = 'none';
      this.$refs.passwordInput3.style.display = 'none';
    },
    validatePassword() {
      const passwordInput1 = this.$refs.passwordInput1;
      const passwordInput2 = this.$refs.passwordInput2;
      const passwordInput3 = this.$refs.passwordInput3;
      const currentPassword = this.currentPassword;
      const newPassword = this.newPassword;
      const newPasswordConfirm = this.newPasswordConfirm;
      
      this.initErrorMessage();

      let result = true;
      const regexAlphabets = /^.{8,16}$/;
      if (currentPassword === '') {
        passwordInput1.innerHTML = this.$i18n.t('companyinfo_currentpw_placeholder');
        passwordInput1.style.display = 'block';
        passwordInput2.style.display = 'none';
        passwordInput3.style.display = 'none';
        result = false;
      } else if (newPassword === '') {
        passwordInput2.innerHTML = this.$i18n.t('companyinfo_newpw_placeholder');
        passwordInput1.style.display = 'none';
        passwordInput2.style.display = 'block';
        passwordInput3.style.display = 'none';
        result = false;
      } else if (newPasswordConfirm === '') {
        passwordInput3.innerHTML = this.$i18n.t('companyinfo_confirmpw_placeholder');
        passwordInput1.style.display = 'none';
        passwordInput2.style.display = 'none';
        passwordInput3.style.display = 'block';
        result = false;
      } else if (!regexAlphabets.test(newPassword)) {
        passwordInput2.innerHTML = this.$i18n.t('companyinfo_pw_regex');
        passwordInput1.style.display = 'none';
        passwordInput2.style.display = 'block';
        passwordInput3.style.display = 'none';
        result = false;
      } else if (newPassword !== newPasswordConfirm) {
        passwordInput3.innerHTML = this.$i18n.t('companyinfo_pw_nomatch_err');
        passwordInput1.style.display = 'none';
        passwordInput2.style.display = 'none';
        passwordInput3.style.display = 'block';
        result = false;
      } else {
        this.initErrorMessage();
      }
      return result;
    },
    async changePassword() {
      if (this.validatePassword()) {
        const obj = {};
        obj.currentPassword = this.currentPassword;
        obj.newPassword = this.newPassword;
        try {
          const response = await this.$apiInstance.post(`/companies/changePassword`, obj);
          if (response.status === 200 || response.status === 201) {
            oneBtnDialog(this.$i18n.t('companyinfo_pw_done_title'), this.$i18n.t('companyinfo_pw_done_content'), true);
          } 
        } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 400) {
            oneBtnDialog(this.$i18n.t('companyinfo_pw_current_err_title'), this.$i18n.t('companyinfo_pw_current_err_content'), false);
          } else {
            oneBtnDialog(this.$i18n.t('companyinfo_pw_other_err_title'), this.$i18n.t('companyinfo_pw_other_err_content'), false);
          }
        }
      }
    },
    // 로고 이미지 onChange메소드 및 미리보기
    async changeLogoImage() {
      const fileInput = document.getElementById('fileInputW');
      if (fileInput.files && fileInput.files[0]) {
        const validateFile = this.validateFile(fileInput.files[0]);
        if (validateFile) {
          const reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById('imgPrevW').src = e.target.result;
          };
          reader.readAsDataURL(fileInput.files[0]);
          this.data.fileName = fileInput.files[0].name;

          const formData = new FormData();
          formData.append('file', fileInput.files[0]);
          this.data.fileData = formData;
          try {
            const imageUrl = await this.uploadImageOnObjectStorage(formData);
            const obj = {};
            obj.imgUrl = imageUrl;
            const response = await this.$apiInstance.post(`/companies/changeLogoImg`, obj);
            if(response.status === 200 || response.status === 201) {
              this.data.profileImgUrl = imageUrl;
              this.$store.dispatch('setUserInfo', {
                companyImageUrl: imageUrl,
              });
            }
          } catch(error) {
            console.log(error);
            oneBtnDialog(this.$i18n.t('companyinfo_img_err_title'), this.$i18n.t('companyinfo_img_err_content'), false);
          }
        }
      }
    },
    downloadLogoImage() {
      const fileInput = this.$refs.fileInputW;
      if(fileInput) {
        const file = fileInput.files[0];
        if (file) {
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(file);
          downloadLink.download = file.name;
          downloadLink.click();
        } else {
          const downloadLink = document.createElement('a');
          downloadLink.target = '_blank';
          downloadLink.href = this.logoImgUrl;
          downloadLink.download = this.logoFileName;
          downloadLink.click();
        }
      } else {
        const downloadLink = document.createElement('a');
        downloadLink.target = '_blank';
        downloadLink.href = this.logoImgUrl;
        downloadLink.download = this.logoFileName;
        downloadLink.click();
      }
    },
    async clickFileInput() {
      // await this.deleteImage();
      let fileInput = document.getElementById('fileInputW');
      fileInput.click();
    },
    async deleteImage() {
      this.data.fileData = '';
      this.data.fileName = null;
      this.data.profileImgUrl = '';
      try {
        const obj = {};
        obj.imgUrl = '';
        const response = await this.$apiInstance.post(`/companies/changeLogoImg`, obj);
        if(response.status === 200 || response.status === 201) {
          this.data.profileImgUrl = imageUrl;
          this.$store.dispatch('setUserInfo', {companyImageUrl: imageUrl});
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 파일 형식 valitdate
    validateFile(file) {
      let result = true;
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg'
      ) {
        alert(this.$i18n.t('hospitalw_message_file_type'));
        result = false;
      } else if (changeBytesToMegabytes(file.size) > 100) {
        alert(this.$i18n.t('hospitalw_message_file_size'));
        result = false;
      }

      return result;
    },
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return companyLogos.default;
      }
    },
  },
};
</script>


<style lang="scss" scoped>

@media screen and (max-width:767px) {
  .hospital-div-wrap .button-box{
    margin-left: 0;
  }
  .hospital-div-wrap .password-area button{
    top:44px;
  }
  .hospital-div-wrap .password-area button.certi-btn-regular{
    position: relative;
    margin-right:0 !important;
    right: 0;
    width:100%;
    top:0;
  }
  .hospital-div-wrap .password-area button.certi-btn-regular.certi-gray-btn{
    margin-top: 10px;
  }
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }

  .content-wrap-card .inputDiv{
    display: flex;
    flex-direction: column;
  }

  .content-wrap-card .inputDiv,
  .content-wrap-card .inputDiv .input-text-common{
    width: 100% !important;
    max-width: none;
  }
}
</style>
<style lang="scss" scoped>
  label {
    align-items: center;
  }
</style>